module.exports = __webpack_public_path__ + "static/img/bg-tr.1f93d73f.png";